import { useTranslation } from 'react-i18next';
import { LabeledCheckbox } from '~/components/common/LabeledCheckbox';

type IncludeInventoryLengthsToggleProps = {
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
  readonly className?: string;
};

export function IncludeInventoryLengthsToggle({
  checked,
  onChange,
  className,
}: IncludeInventoryLengthsToggleProps) {
  const { t } = useTranslation('general');
  return (
    <LabeledCheckbox
      checked={checked}
      onChange={onChange}
      label={t('include_inventory_lengths')}
      testId="include-inventory-lengths-toggle"
      className={className}
    />
  );
}
